import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification_filterActions } from "../actions";

function useWorkspaceFilterHook() {
    const debounceRef = useRef(null);
    const dispatch = useDispatch();
    const SEND_DELAY = 500; // milliseconds
    

    const  { 
        id, 
        unselected_workspace_ids, 
        unselected_organization_ids 
    } = useSelector(state => state.notification_filter);

    useEffect(() => {
        if(id){
            const sendSelection = (formData = {}, id) => {
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current);
                }
                debounceRef.current = setTimeout(async () => {
                    dispatch(notification_filterActions.updateNotificationFilter({
                                                                                    id,
                                                                                    formData
                                                                                }));
                }, SEND_DELAY);
            }

            sendSelection({
                unselected_workspace_ids,
                unselected_organization_ids
            },id);
        }
    }, [unselected_workspace_ids, unselected_organization_ids]);

    return {};
}

export default useWorkspaceFilterHook;